<template>
  <section
    class="background w-screen flex items-center justify-center flex-col h-screen fixed top-0 left-0"
  > 
    <div
      class="box-complete-items-msg flex flex-col md:flex-row space-y-4 md:space-x-8 justify-center items-center md:items-start pb-8"
    >
      <div class="w-full h-[95vh]" style="max-width: 1060px">
        <div
          class="bg-white rounded-lg p-8 flex flex-col justify-start border-b-4 h-full border-h-primary-500 mt-4"
        >
          <div
            class="flex flex-col md:flex-row space-x-0 md:space-x-8 items-center"
          >
            <img :src="homeroAvatar" class="avatar-homero mt-6 lg:flex hidden" alt="" />
            <div class="lg:mt-8 md:mt-0">
              <div class="flex justify-between flex-row space-x-2 items-center">
                  <div class="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
                  <div class="flex w-full sm:w-auto items-center justify-between">
                    <div class="flex items-center space-x-2">
                      <img src="@/assets/images/research-icon.svg" alt="" />
                      <h4 class="text-h-primary-800">
                        {{ $t("labels.generic", { pt: "Pesquisa", en: "Survey" }) }}
                      </h4>
                    </div>
                    <div class="block sm:hidden">
                      <MessageVoice
                        msg="Parabéns, você finalizou todo o objetivo ! Para melhorarmos ainda mais nosso conteúdo, pedimos por favor que classifique as afirmações abaixo em uma escala de 1 (Discordo totalmente) a 5 (Concordo totalmente)."
                        :scaleIcons="0.8"
                        :showIconsName="false"
                      />
                    </div>
                  </div>
                  <div class="w-full sm:w-auto flex flex-col sm:flex-row sm:items-center sm:gap-4">
                    <div class="hidden sm:block">
                      <MessageVoice
                        msg="Parabéns, você finalizou todo o objetivo ! Para melhorarmos ainda mais nosso conteúdo, pedimos por favor que classifique as afirmações abaixo em uma escala de 1 (Discordo totalmente) a 5 (Concordo totalmente)."
                        :scaleIcons="0.8"
                        :showIconsName="false"
                      />
                  </div>
                  <Button
                    :class="`${
                      surveyComplete ? 'btn-primary' : 'btn-disabled'
                    } w-full sm:w-[100px] h-[50px] rounded-md flex justify-center mt-2 sm:mt-0`"
                    @click="sendFeedback()"
                  >
                    {{ $t("labels.generic", { pt: "Enviar", en: "Send" }) }}
                  </Button>
                </div>
              </div>
            </div>
              <p class="w-full md:w-[85%] mt-8 min-w-[300px]">
                {{
                  $t("labels.generic", {
                    pt: "Parabéns, você finalizou todo o objetivo ! Para melhorarmos ainda mais nosso conteúdo, pedimos por favor que classifique as afirmações abaixo em uma escala de",
                    en: "Congratulations, you have completed the entire objective ! To further improve our content, please rate the statements below on a scale of",
                  })
                }}

                <strong>
                  {{
                    $t("labels.generic", {
                      pt: "1 (Discordo totalmente) a 5 (Concordo totalmente).",
                      en: "1 (Strongly Disagree) to 5 (Strongly Agree).",
                    })
                  }}
                </strong>
              </p>
            </div>
          </div>
          <!-- survey -->
          <div class="survey overflow-auto mt-8">
            <div class="h-[90%] mt-4 sm:pr-4">
              <div
                v-for="statement in survey"
                :key="statement"
                :class="`mb-8 ${
                  statement.answered === false
                    ? 'border-2 border-red-500 p-2 rounded-md'
                    : ''
                }`"
              >
                <p>{{ statement.prompt }}</p>
                <div class="flex flex-row justify-between mt-4">
                  <button
                    v-for="index in 5"
                    :key="index"
                    :class="`space-y-2 border-2 ${
                      statement.rate == index
                        ? 'bg-yellow-100 border-yellow-600'
                        : 'btn-h-info'
                    } p-2 rounded-md shadow-md`"
                    @click="
                      statement.rate = index;
                      statement.answered = true;
                    "
                  >
                    <img
                      :src="
                        require('@/assets/images/emojis/emoji-' +
                          index +
                          '.svg')
                      "
                      alt="emojis"
                    />
                    <p>{{ index }}</p>
                  </button>
                </div>
                <p
                  class="mt-4 text-h-error-400 text-[12px]"
                  v-if="statement.answered === false"
                >
                  {{
                    $t("labels.generic", {
                      pt: "Campo obrigatório",
                      en: "Required field",
                    })
                  }}
                </p>
              </div>
              <div class="mt-12">
                <p>
                  {{
                    $t("labels.generic", {
                      pt: "Como tem sido a sua experiência geral com a plataforma? Deseja fazer algum comentário, como elogio ou sugestão? (Opcional)",
                      en: "How has your overall experience with the platform been? wish make a comment, like a compliment or a suggestion? (Optional)",
                    })
                  }}
                </p>
                <div class="mt-4">
                  <Textarea
                    v-model="comment"
                    rows="5"
                    maxlength="500"
                  ></Textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FeedbackRest } from "@/services/rest/feedback.rest";
import { useFeedbackStore } from "@/store/adaptative/feedback";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject } from "rxjs";
import { defineComponent } from "vue";

export var feedbackObjectiveIsOpen$ = new BehaviorSubject<boolean>(false);

export default defineComponent({
  name: "feedback-objective",
  emits: ["onSendFeedback"],
  data() {
    return {
      homeroAvatar: require("/src/assets/images/avatares/avatar.svg"),
      feedbackStore: useFeedbackStore,
      survey: [
        {
          prompt:
            "O material utilizado para a apresentação do conteúdo está adequado ao objetivo proposto." as string,
          rate: 0 as number,
          answered: null,
        },
        {
          prompt:
            "A apresentação do conteúdo em mais de um formato (texto, vídeo, slide) contribuiu com a sua aprendizagem." as string,
          rate: 0 as number,
          answered: null,
        },
        {
          prompt:
            "As avaliações estavam de acordo com o conteúdo disponibilizado." as string,
          rate: 0 as number,
          answered: null,
        },
        {
          prompt:
            "As avaliações disponíveis contribuem com seu processo de aprendizagem." as string,
          rate: 0 as number,
          answered: null,
        },
        {
          prompt:
            "As correções das avaliações são importantes na continuidade dos seus estudos." as string,
          rate: 0 as number,
          answered: null,
        },
        {
          prompt:
            "Os diálogos realizados pelo Homero, contribuíram para seu processo de aprendizagem." as string,
          rate: 0 as number,
          answered: null,
        },
        {
          prompt:
            "Em relação ao funcionamento da plataforma, você está satisfeito(a)." as string,
          rate: 0 as number,
          answered: null,
        },
      ] as Array<any>,
      surveyComplete: false as boolean,
      comment: "" as string,
      loader: false,
    };
  },
  mounted() {
    feedbackObjectiveIsOpen$.next(true);
  },
  unmounted() {
    feedbackObjectiveIsOpen$.next(false);
  },
  computed: {
    rest(): FeedbackRest {
      return new FeedbackRest();
    },
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
  },
  watch: {
    survey: {
      handler: function (val, oldVal) {
        this.surveyComplete = this.autoVerifySurvey();
      },
      deep: true,
    },
  },
  props: {
    itemId: {
      required: true,
      type: String,
    },
    idUser: {
      type: String,
      default: "user",
    },
    idCourse: {
      type: String,
      default: "course",
    },
  },
  methods: {
    sendFeedback(): void {
      this.verifySurvey();
      if (this.surveyComplete && !this.loader) {
        this.loader = true;
        const data = {
          feedbackQuestionList: this.survey,
          feedbackText: this.comment,
          clientTime: new Date().toISOString(),
        };
        this.$emit("onSendFeedback", data);
      }
    },
    autoVerifySurvey(): boolean {
      for (let i = 0; i < this.survey.length; i++) {
        if (this.survey[i].rate == 0) {
          return false;
        } else {
          this.survey[i].answered = true;
        }
      }
      return true;
    },
    verifySurvey(): void {
      for (let i = 0; i < this.survey.length; i++) {
        if (this.survey[i].rate == 0) {
          this.survey[i].answered = false;
        } else {
          this.survey[i].answered = true;
        }
      }
    },
  },
});
</script>
